import React from "react"
import PropTypes from "prop-types"
import CSVButton from "@swipesense/csv-button"
import "./CSVLink.scss"

const CSVLink = (props) => {
  return (
    <div className="CSVLink">
      <CSVButton
        data={props.data}
        filename={props.filename}
        headers={props.headers}
        mapData={props.mapData}
      />
    </div>
  )
}

CSVLink.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  filename: PropTypes.string.isRequired,
  headers: PropTypes.arrayOf(PropTypes.object).isRequired,
  mapData: PropTypes.func.isRequired,
}

export default CSVLink
